import PropTypes from 'prop-types';

const PlantTaskFilter = ({ activeFilter, filterOptions, plantTaskConfig, changeFilter }) => {

  return (
    <div className='filter-bar-container'>
        <div className="filter-bar">
          <div
            className={`filter-link ${activeFilter === "" ? "active" : ""}`}
            onClick={() => changeFilter("")}
          >
          {'All'}
          </div>
        
        {filterOptions.map((option) => (
          <div
            key={option}
            className={`filter-link ${activeFilter === option ? "active" : ""}`}
            onClick={() => changeFilter(option)}
          >
            {plantTaskConfig[option].label}
          </div>
        ))}
      </div>
    </div>
  );
};

PlantTaskFilter.propTypes = {
  activeFilter: PropTypes.string.isRequired,
  filterOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  plantTaskConfig: PropTypes.object.isRequired,
  changeFilter: PropTypes.func.isRequired
};

export default PlantTaskFilter;
